import { render, staticRenderFns } from "./EditCorporateCustomer.vue?vue&type=template&id=dde74e74&"
import script from "./EditCorporateCustomer.vue?vue&type=script&lang=js&"
export * from "./EditCorporateCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports